import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

function SunIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M21 12.7A8.5 8.5 0 0 1 11.3 3a7 7 0 1 0 9.7 9.7Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function ThemeToggle({ theme, onToggle }) {
  const isDark = theme === 'dark';

  const label = useMemo(() => (isDark ? 'Switch to light mode' : 'Switch to dark mode'), [isDark]);

  return (
    <button className="theme-toggle" type="button" onClick={onToggle} aria-label={label}>
      <span className="theme-toggle__icon">
        <motion.span
          key={isDark ? 'moon' : 'sun'}
          initial={{ opacity: 0, y: 6, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -6, scale: 0.98 }}
          transition={{ duration: 0.18 }}
          style={{ display: 'inline-flex' }}
        >
          {isDark ? <MoonIcon /> : <SunIcon />}
        </motion.span>
      </span>
      <span className="theme-toggle__text">{isDark ? 'Dark' : 'Light'}</span>
    </button>
  );
}

